import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import { Link, useLocation } from "react-router-dom";
import PageRoutes from "../../utils/routes";

const { Paragraph, Text } = Typography;

const ErrorPage = () => {
  const location = useLocation();
  const { errorMessage, errorCode } = location.state || {}; // Access errorMessage and errorCode from location state
  const handleGoBack = () => {
    window.history.back(); // Tarayıcı geçmişini kullanarak bir önceki sayfaya dön
  };

  return (
    <Result
      status="error"
      title="İşlem Başarısız"
      subTitle="Lütfen aşağıdaki bilgi mesajını takip ederek tekrar deneyiniz."
      extra={
        <div>
          <Button
            type="default"
            onClick={handleGoBack}
            style={{ marginRight: "10px" }}
          >
            Geri Dön
          </Button>
          <Link to={PageRoutes.home}>
            <Button type="primary">Ana Sayfa</Button>
          </Link>
        </div>
      }
    >
      <div className="desc">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            Aşağıdaki hata alındı:
          </Text>
        </Paragraph>
        <Paragraph>
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          {errorMessage} (Hata Kodu: <Text strong>{errorCode}</Text>)
        </Paragraph>
      </div>
    </Result>
  );
};
export default ErrorPage;
